module.exports = __webpack_public_path__ + "static/media/sj.f4043368.svg";